import { BrandAttachment, BrandAddress } from 'models/brand';

export enum Language {
    De = 'de',
    En = 'en',
    Nl = 'nl'
}

export enum ContactType {
    Main = 'main',
    AccessRequests = 'accessRequests',
    OrderConfirmation = 'orderConfirmation',
    RetailerStoresUpdates = 'retailerStoresUpdates',
    Sustainability = 'sustainability'
}

export interface ContactLanguage {
    key: Language;
    name: string;
    flag: string;
}

export interface Contact {
    name: string;
    email: string;
    preferredLanguage: string;
    phone?: string;
}

export interface Price {
    value: number;
    currency: string;
}

export interface BrandData {
    name: string;
    contacts: {
        [ContactType.Main]: Contact;
        [ContactType.Sustainability]?: Contact;
    };
    website?: string;
    phone: string;
    description: string;
    gln?: string;
    glns?: Array<string>;
    logo: any;
    banner?: any;
    mainCategories?: string[];
    priceLevel?: string[];
    lookbooks?: BrandAttachment[];
    sustainability?: {
        website: string;
        certificates: string[];
        memberships: string[];
        reports: BrandAttachment[];
    };
    promoImage: any;
    address?: BrandAddress;
}
